import React from "react";
import { css } from "styled-components";
import { applyStyles } from "util/helpers";
import Colors from "constants/colors";
import FontStyles from "constants/font-styles";
import i18n from 'i18n';
import CustomMedia from 'util/custom-media-query';

const Content = ({ className })  => (
  <div className={className}>
    <ul>
      {
        i18n.t('about:delivery:content.additions', { returnObjects: true }).map((addition, i)=>(
          <li key={i}>{addition}</li>
        ))
      }
      {/** お盆情報 */}
      {i18n.t('notice:obon.show') &&
        <li>
          <div>{i18n.t('notice:obon.messages.1')}</div>
          <div>{i18n.t('notice:obon.messages.2')}</div>
          <div>{i18n.t('notice:obon.messages.3')}</div>
          <div>{i18n.t('notice:obon.messages.4')}</div>
          <div>{i18n.t('notice:obon.messages.5')}</div>
          <div>{i18n.t('notice:obon.messages.6')}</div>
        </li>
      }
      {
        i18n.t('notice:delivery.show') &&
        <li>
          <div>{i18n.t('notice:delivery.messages.1')}</div>
          <div>{i18n.t('notice:delivery.messages.2')}</div>
          <div>{i18n.t('notice:delivery.messages.3')}</div>
          <div>{i18n.t('notice:delivery.messages.4')}</div>
          <div>{i18n.t('notice:delivery.messages.5')}</div>
          <div>{i18n.t('notice:delivery.messages.6')}</div>
          <div>{i18n.t('notice:delivery.messages.7')}</div>
        </li>
        }
    </ul>
  </div>
)

const commonStyle = css`
  .list-title {
    display: inline-block;
    color: ${Colors.black1};
    border-bottom: 1px solid ${Colors.orange1};
  }

  ul {
    padding-left: 13px;

    li {
      ${FontStyles.text8};
      color: ${Colors.black1};
      list-style: none;
      position: relative;
      white-space: pre-line;

      &:before {
        content: '●';
        position: absolute;
        left: -11px;
        font-size: 7px;
      }
    }
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  margin-top: 42px;

  .list-title {
    margin: -2px 0 0 0;
    ${FontStyles.text7};
  }

  ul {
    margin: 11px 0 0 0;
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  margin-top: 22px;

  .list-title {
    margin: 0;
    ${FontStyles.text5};
  }

  ul {
    margin: 4px 0 0 0;

    li {
      ${FontStyles.text6}
    }
  }
`;

export default applyStyles(Content)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/About/Delivery/components/Content.js